/**
 * Creates an equals predicate, binding the left parameter.
 * @param op1
 * @returns {function(*): boolean}
 */
export const equals = op1 => op2 => op1 === op2;
/**
 * Creates a predicate that checks if the operand is included in the bound list.
 * @param {Array} list
 * @returns {function(*=): boolean}
 */
export const includedIn = list => op => list && list.includes(op);
/**
 * Creates a predicate that checks if the operand is included in the bound list.
 * @param {string} tail
 * @returns {function(string): boolean}
 */
export const endsWith = tail => str => str && str.endsWith(tail);